import { Record } from 'immutable';

export default class SmsRecord extends Record({
  id: null,
  message: null,
  createdAt: null,
  fromNumber: null,
  resources: null,
  note: null,
  isHandled: false,
}) {
}
